import { Link } from "react-router-dom";
import { ArrowRight, FileText, Briefcase, Receipt } from "lucide-react";
import { StatusBadge } from "@/components/common";

export const ACCEPT_METHOD_LABELS = { phone: "Phone", text: "Text", in_person: "In Person", email: "Email", other: "Other", public_link: "Customer link" };

export const acceptanceLabel = (q) => {
  if (!q?.accepted_at) return null;
  if (q.acceptance_source === "internal") return `Accepted by staff (${ACCEPT_METHOD_LABELS[q.acceptance_method] || "Other"})`;
  if (q.acceptance_source === "customer") return "Accepted by customer online";
  return "Accepted";
};

const Step = ({ icon: Icon, label, to, status, sub, active, testId }) => {
  const inner = (
    <div className={`flex items-center gap-2 rounded-xl border px-3 py-2 ${active ? "bg-white border-slate-200" : "bg-slate-50 border-dashed border-slate-200 text-slate-400"}`} data-testid={testId}>
      <Icon size={15} className={active ? "text-orange-500" : "text-slate-300"} />
      <div className="leading-tight">
        <div className="text-sm font-semibold">{label}</div>
        {sub && <div className="text-[11px] text-slate-500">{sub}</div>}
      </div>
      {status && <StatusBadge status={status} className="ml-1" />}
    </div>
  );
  return to ? <Link to={to} className="hover:opacity-80">{inner}</Link> : inner;
};

export function WorkflowTrail({ quote, job, invoice, current }) {
  return (
    <div className="flex flex-wrap items-center gap-2 text-slate-700" data-testid="workflow-trail">
      <Step icon={FileText} label={quote ? `Quote ${quote.number}` : "No quote"} to={quote && current !== "quote" ? `/quotes/${quote.id}` : null} status={quote?.status} sub={acceptanceLabel(quote)} active={!!quote} testId="trail-quote" />
      <ArrowRight size={14} className="text-slate-300" />
      <Step icon={Briefcase} label={job ? `Job ${job.number}` : "Job not created"} to={job && current !== "job" ? `/jobs/${job.id}` : null} status={job?.status} active={!!job} testId="trail-job" />
      <ArrowRight size={14} className="text-slate-300" />
      <Step icon={Receipt} label={invoice ? `Invoice ${invoice.number}` : "Invoice not created"} to={invoice && current !== "invoice" ? `/invoices/${invoice.id}` : null} status={invoice?.status} active={!!invoice} testId="trail-invoice" />
    </div>
  );
}
